import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    id: 1,
    title: 'Recetario Especial de Budines Salados',
    image: 'https://cdn.magicpatterns.com/uploads/g9AaoEg2otWtRz43zT2yt6/bono_1.png',
    description: 'Aprendé a preparar budines salados ideales para picadas, desayunos, almuerzos o cenas rápidas. Recetas simples que combinan queso, verduras y otros ingredientes para crear budines salados deliciosos.'
  }, {
    id: 2,
    title: 'Guía de Coberturas y Glaseados para Budines',
    image: 'https://cdn.magicpatterns.com/uploads/8ypHRLb9VEDK6jfR25tRfv/bono_2.png',
    description: 'Una guía complementaria con técnicas avanzadas y secretos de pastelería para que tus coberturas queden siempre perfectas y brillantes.'
  }, {
    id: 3,
    title: 'Kit para Empezar a Vender Budines Caseros',
    image: 'https://cdn.magicpatterns.com/uploads/96MkCzRENFR6zfrQegjT5j/bono_3.png',
    description: 'Si querés convertir esta habilidad en un ingreso extra, este bono te muestra: Cómo calcular precios, Cómo presentar los budines, Ideas simples para vender desde casa.'
  }, {
    id: 4,
    title: 'Tabla de Conversiones y Trucos de Repostería',
    image: 'https://cdn.magicpatterns.com/uploads/uzVcmMiLu1ipfH9uEDEbht/bono_4.png',
    description: 'Una guía rápida con proporciones, equivalencias y pequeños secretos que hacen una gran diferencia en el resultado final.'
  }];
  return <section className="py-24 bg-gradient-to-b from-[#FFF5EB] to-[#FFF8F0] text-[#3D2B1F] px-4 relative" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black mb-6 leading-tight max-w-4xl mx-auto text-transparent bg-clip-text bg-gradient-to-r from-[#3D2B1F] to-[#6B5344]" data-id="element-21">
            Y para aumentar aún más el valor de este pack, también vas a recibir
            bonos exclusivos.
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-22">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-[2rem] p-8 border border-[#3D2B1F]/10 relative overflow-hidden group hover:border-[#C67B30]/30 transition-colors duration-300 shadow-lg" data-id="element-23">
              <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full text-sm z-10 shadow-lg animate-pulse" data-id="element-24">
                🎁 ¡GRATIS POR HOY!
              </div>

              <div className="relative cursor-pointer mb-8 overflow-hidden rounded-2xl" onClick={scrollToOffer} data-id="element-25">
                <div className="absolute inset-0 bg-gradient-to-t from-[#3D2B1F]/40 to-transparent z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6" data-id="element-26">
                  <span className="bg-[#C67B30] text-white font-bold px-6 py-2 rounded-full transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-27">
                    Ver Oferta
                  </span>
                </div>
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-contain transform transition-transform duration-500 group-hover:scale-105" data-id="element-28" />
              </div>

              <h3 className="text-2xl font-bold text-[#C67B30] mb-4" data-id="element-29">
                Bono #{bonus.id}: {bonus.title}
              </h3>
              <p className="text-[#6B5344] text-lg leading-relaxed" data-id="element-30">
                {bonus.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}